<template>
  <v-card>
    <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
    <v-card-title>
      <h4 class="mb-0">Uppdatering av senaste ändringsdatum</h4>
    </v-card-title>

    <v-card-text>
      <MessageBox class="mb-4">
        <p class="bold">Handledarinstruktionerna är uppdaterade och den nya versionen har publicerats.</p>
      </MessageBox>
      <p>
        Du kan välja att också uppdatera datum för senaste ändring av instruktionerna. Ändring av detta datum kommer
        innebära att handledare på Mina sidor måste bekräfta de nya handledarinstruktionerna.
      </p>
      <v-form ref="form">
        <v-switch v-model="shouldUpdateDate" label="Uppdatera ändringsdatum för handledarinstruktionerna"></v-switch>
        <div v-if="shouldUpdateDate">
          <div class="ml-12">
            <DatePicker
              v-model="committedAt"
              ref="datePicker"
              :icon="'$sl-calendar-date'"
              :width="'250'"
              outlined
              :required="false"
            />
            <p>
              Sammanfatta ändringarna du gjort på ett sånt sätt att en handledare kan förstå vad som ändrats utan att
              behöva läsa hela instruktionstexten.
            </p>
            <v-textarea
              outlined
              v-model="commitMessage"
              :error-messages="inputErrors"
              @input="clearErrorMessages"
            ></v-textarea>
          </div>
        </div>
      </v-form>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn
        color="secondary"
        @click="
          clearErrorMessages()
          $emit('close')
        "
      >
        <v-icon>$sl-cancel</v-icon>Avbryt
      </v-btn>
      <v-btn class="icon" :disabled="!shouldUpdateDate" @click="saveSub()"> <v-icon>$sl-check</v-icon>Spara </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {RulesMixin} from '@/components/mixins'
import DatePicker from '@/components/common/DatePicker'
import MessageBox from '@/components/common/MessageBox.vue'

export default {
  name: 'PublishModal',

  props: {},

  data: () => ({
    shouldUpdateDate: false,
    committedAt: `${new Date()}`,
    commitMessage: '',
    inputErrors: null
  }),

  mixins: [RulesMixin],

  components: {
    DatePicker,
    MessageBox
  },

  methods: {
    saveSub() {
      if (this.shouldUpdateDate && !this.commitMessage) {
        this.inputErrors = 'Sammanfattning måste anges när ändringsdatum uppdateras.'
        return
      }
      this.$emit('publish', {
        shouldUpdateDate: this.shouldUpdateDate,
        committedAt: this.committedAt,
        commitMessage: this.commitMessage
      })
    },
    clearErrorMessages() {
      this.inputErrors = null
    }
  }
}
</script>

<style lang="scss" scoped>
</style>